import {
	WORKER_STATS_LOADING,
	WORKER_STATS_HOURLY_GET,
	WORKER_STATS_HOURLY_ERROR,
	WORKER_STATS_DAILY_GET,
	WORKER_STATS_DAILY_ERROR,
	WORKER_STATS_DAYS_GET,
	WORKER_STATS_DAYS_ERROR,
	WORKER_STATS_CURRENT_GET,
	WORKER_STATS_CURRENT_ERROR,
	WORKER_STATS_PERFORMANCE_GET,
	WORKER_STATS_PERFORMANCE_ERROR,
	WORKER_STATS_SUMMARY_GET,
	WORKER_STATS_SUMMARY_ERROR,
	WORKER_STATS_TYPE_GET,
	WORKER_STATS_TYPE_ERROR,
	WORKER_STATS_PEAK_GET,
	WORKER_STATS_PEAK_ERROR,
	WORKER_STATS_COMPARISON_GET,
	WORKER_STATS_COMPARISON_ERROR,
	WORKER_STATS_ANOMALIES_GET,
	WORKER_STATS_ANOMALIES_ERROR
} from '../actions/types';

const initialState = {
	worker_stats_loading: false,
	worker_stats_hourly: { data: [] },
	worker_stats_daily: { data: [] },
	worker_stats_days: { data: [] },
	worker_stats_current: { data: {} },
	worker_stats_performance: { data: {} },
	worker_stats_summary: { data: {} },
	worker_stats_type: { data: {} },
	workers_stats_peak: { data: {} },
	workers_stats_comparison: { data: {} },
	worker_stats_anomalies: { data: {} },
	worker_stats_errors: {}
}

export default function workerStatsReducer(state = initialState, action){
	switch(action.type){
		case WORKER_STATS_LOADING:
			return {
				...state,
				worker_stats_loading: action.payload
			}
		case WORKER_STATS_HOURLY_GET:
			delete state.worker_stats_errors.worker_stats_hourly
			return {
				...state,
				worker_stats_hourly: action.payload
			}
		case WORKER_STATS_DAILY_GET:
			delete state.worker_stats_errors.worker_stats_daily
			return {
				...state,
				worker_stats_daily: action.payload
			}
		case WORKER_STATS_DAYS_GET:
			delete state.worker_stats_errors.worker_stats_days
			return {
				...state,
				worker_stats_days: action.payload
			}
		case WORKER_STATS_CURRENT_GET:
			delete state.worker_stats_errors.worker_stats_current
			return {
				...state,
				worker_stats_current: action.payload
			}
		case WORKER_STATS_PERFORMANCE_GET:
			delete state.worker_stats_errors.worker_stats_performance
			return {
				...state,
				worker_stats_performance: action.payload
			}
		case WORKER_STATS_SUMMARY_GET:
			delete state.worker_stats_errors.worker_stats_summary
			return {
				...state,
				worker_stats_summary: action.payload
			}
		case WORKER_STATS_TYPE_GET:
			delete state.worker_stats_errors.worker_stats_type
			return {
				...state,
				worker_stats_type: action.payload
			}
		case WORKER_STATS_PEAK_GET:
			delete state.worker_stats_errors.worker_stats_peak
			return {
				...state,
				workers_stats_peak: action.payload
			}
		case WORKER_STATS_COMPARISON_GET:
			delete state.worker_stats_errors.worker_stats_comparison
			return {
				...state,
				workers_stats_comparison: action.payload
			}
		case WORKER_STATS_ANOMALIES_GET:
			delete state.worker_stats_errors.worker_stats_anomalies
			return {
				...state,
				worker_stats_anomalies: action.payload
			}
		case WORKER_STATS_HOURLY_ERROR:
		case WORKER_STATS_DAILY_ERROR:
		case WORKER_STATS_DAYS_ERROR:
		case WORKER_STATS_CURRENT_ERROR:
		case WORKER_STATS_PERFORMANCE_ERROR:
		case WORKER_STATS_SUMMARY_ERROR:
		case WORKER_STATS_TYPE_ERROR:
		case WORKER_STATS_PEAK_ERROR:
		case WORKER_STATS_COMPARISON_ERROR:
		case WORKER_STATS_ANOMALIES_ERROR:
			return {
				...state,
				worker_stats_errors: {
					...state.worker_stats_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
